export const API_BASE_URL = '/api/properties';

export const LOCALSTORAGE_KEYS = {
  FILTERS: 'winnipegPropertyFilters',
  RESULTS: 'winnipegPropertyResults',
  TOTAL_COUNT: 'winnipegPropertyTotalCount',
  FAVORITES: 'winnipegPropertyFavorites',
  TAGS: 'winnipegPropertyTags',
  TAG_MAPPING: 'winnipegPropertyTagMapping'
};

export const DEFAULT_FILTERS = {
  streetName: '',
  minYear: '',
  maxYear: '',
  minArea: '',
  maxArea: '',
  minValue: '',
  maxValue: '',
  propertyType: '',
  buildingType: '',
  basement: '',
  garage: '',
  pool: '',
  airConditioning: '',
  riverAdjacent: false,
  favoritesOnly: false,
  selectedTags: [],
  // Sales search filters
  minSalePrice: '',
  maxSalePrice: '',
  minSaleYear: '',
  maxSaleYear: '',
  salesBuildingType: '',
  salesAddress: ''
};

export const PROPERTY_TYPES = {
  RESIDENTIAL: 'Residential',
  CONDOMINIUM: 'Condominium',
  MULTI_FAMILY: 'Multi-Family',
  VACANT_LAND: 'Vacant Land'
};

export const VIEWS = {
  SEARCH: 'search',
  DETAIL: 'detail',
  FAVORITES: 'favorites',
  COLLECTIONS: 'collections'
};

export const VIEW_MODES = {
  GRID: 'grid',
  MAP: 'map'
};

export const SEARCH_MODES = {
  ADDRESS: 'address',
  FILTERS: 'filters',
  SALES: 'sales'
};

export const PAGINATION = {
  PAGE_SIZE: 250,
  MAX_RESULTS: 250
};

export const DEFAULT_TAG_COLOR = '#3B82F6';

export const ROUTES = {
  HOME: '#/',
  PROPERTY: (rollNumber) => `#/property/${rollNumber}`,
  FAVORITES: '#/favorites',
  COLLECTIONS: '#/collections'
};